import { Link } from "react-router-dom";
import { seoArticles } from "@/mocks/seo-articles";

export default function ArticlesSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
            <i className="ri-article-line"></i>
            Полезные статьи
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            Руководства и статьи о Yoybuy Sheet
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            Узнайте всё о шоппинге через Yoybuy: сравнения агентов, гайды по доставке, безопасности и лучшие находки
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all hover:scale-[1.01] cursor-pointer overflow-hidden"
            >
              <div className="relative w-full aspect-[8/5] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-800 text-[10px] font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed mb-4 line-clamp-2">
                  {article.description}
                </p>
                <div className="mt-auto flex items-center justify-between">
                  <div className="flex items-center gap-3 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line text-[10px]"></i>
                      {article.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line text-[10px]"></i>
                      {article.date}
                    </span>
                  </div>
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}